import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private getBrowserLanguage(): string {
    const browserLang = navigator.language || (navigator as any).userLanguage;
    if (browserLang.startsWith('he')) {
      return 'he';
    } else if (browserLang.startsWith('en')) {
      return 'en';
    }
    return 'he';
  }

  public currentLanguage = new BehaviorSubject<string>(
    localStorage.getItem('selectedLanguage') || this.getBrowserLanguage());
  currentLanguage$ = this.currentLanguage.asObservable();
  private switchToLanguageSubject = new BehaviorSubject<string>(this.currentLanguage.getValue() === 'he' ? 'en' : 'he');
  switchToLanguage$ = this.switchToLanguageSubject.asObservable();
  public changeLanguageSubject = new BehaviorSubject<boolean>(false);
  changeLanguage$ = this.changeLanguageSubject.asObservable();

  constructor(private translate: TranslateService) {}

  initializationLanguage() {

    this.translate.addLangs(['he', 'en']);

    this.translate.setDefaultLang(this.currentLanguage.value);
    this.translate.use(this.currentLanguage.value).subscribe(() => {});
  }

  changeLanguage(): void {
    this.changeLanguageSubject.next(true);
    const lang = this.switchToLanguageSubject.getValue();
    if (lang !== this.currentLanguage.getValue()) {
      this.translate.use(lang).subscribe(() => {
        this.switchToLanguageSubject.next(this.currentLanguage.getValue());
        this.currentLanguage.next(lang);
        localStorage.setItem('selectedLanguage', lang);
        this.changeLanguageSubject.next(false);
      });
    }
  }

  getLanguageKeys() {
    return this.translate.get('iaa');
  }

}
